const routeWithId = (base, id) => (id ? `${base}/${id}` : base)

export const getNotificationTarget = (notification) => {
  const type = (notification?.notificationType || "").toLowerCase()
  const foreignKey = notification?.foreignKey
  const tradeId = notification?.tradeId
  if (type === "fellowshipmeetinvite") return routeWithId("/events", foreignKey)
  if (type === "fellowshipupdated") return routeWithId("/group-members", foreignKey)

  if ((type === "messagereply" || type === "chatmessage") && tradeId && foreignKey) {
    return `/forum?topicId=${tradeId}&postId=${foreignKey}`
  }

  if (type.includes("conflict")) {
    return routeWithId("/conflicts", foreignKey)
  }

  if (
    type.includes("campaign") ||
    type === "voterecorded"
  ) {
    return "/dashboard/votes"
  }

  if (
    type.startsWith("group") ||
    type.includes("invitation")
  ) {
    return foreignKey ? `/group-members/${foreignKey}` : "/dashboard"
  }

  if (
    type.startsWith("job") ||
    type.includes("payroll")
  ) {
    return "/jobs"
  }

  if (
    type.startsWith("task") ||
    type.includes("refinement")
  ) {
    return foreignKey ? `/actions/${foreignKey}/refinement` : "/fetch-actions"
  }

  if (
    type.includes("btc") ||
    type.includes("wallet") ||
    type.includes("trade") ||
    type.includes("marketplace")
  ) {
    return "/dashboard/trading-history"
  }

  if (type.includes("friend")) {
    return "/user-search"
  }

  return "/dashboard"
}
